var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountryLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 15,
    fill: "white",
    fillOpacity: 0.03
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 48,
    rx: 14.5,
    stroke: "#D1D9E2",
    strokeOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1501 31.4213C26.7561 32.4989 25.0075 33.1401 23.1091 33.1401C18.5529 33.1401 14.8594 29.4466 14.8594 24.8904C14.8594 20.3341 18.5529 16.6406 23.1091 16.6406C26.2195 16.6406 28.9278 18.3619 30.3335 20.9039",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5126 29.421C25.9742 31.5032 24.4483 33.1401 23.1082 33.1401C20.8102 33.1401 18.9473 29.4466 18.9473 24.8904C18.9473 20.3341 20.8102 16.6406 23.1082 16.6406C24.1075 16.6406 25.0245 17.3391 25.7418 18.5031",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9883 30.4216C18.4979 29.5797 20.6807 29.0508 23.1085 29.0508C24.3224 29.0508 25.4751 29.183 26.513 29.4205",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5575 20.5274C19.1702 20.3002 17.9443 19.8925 16.9883 19.3594",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1094 27.5938V33.1412",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1094 16.6406V18.4116",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8594 24.8906H20.558",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3476 26.4143H22.8114C22.3093 26.4143 21.9023 26.0073 21.9023 25.5052V20.7255C21.9023 20.2234 22.3094 19.8164 22.8114 19.8164H27.5912C28.0933 19.8164 28.5003 20.2234 28.5003 20.7255V21.7811",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8197 22.5547H28.04C27.5379 22.5547 27.1309 22.9617 27.1309 23.4638V28.2435C27.1309 28.7456 27.5379 29.1526 28.04 29.1526H28.6406V30.3548L30.0105 29.1526H32.8197C33.3218 29.1526 33.7288 28.7456 33.7288 28.2435V23.4638C33.7288 22.9617 33.3218 22.5547 32.8197 22.5547Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.166 21.8359H27.2161",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1914 21.0586V21.8375",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3593 21.9141C26.3593 21.9141 26.0477 24.0949 23.3477 25.1334",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.334 23.0039C24.7494 23.6789 25.6321 24.6136 26.9821 25.1328",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9922 27.6152L30.4259 24.0859L31.8597 27.6152",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.457 26.4688H31.3572",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryLanguage);
export default __webpack_public_path__ + "static/media/Country Language.59db9cb039e828606baf3712e730a91b.svg";
export { ForwardRef as ReactComponent };